import sidebarItems from '~/utils/sidebar-items'

export const useSidebar = () => {
  const { user } = useDirectusAuth()
  const localePath = useLocalePath()
  const { locale, t } = useI18n()

  const passesFilter = (item) => {
    // if (hasRequiredRole(user.value?.role, 'admin')) return true

    if ('condition' in item && !item.condition(user.value)) return false

    return !('role' in item && !hasRequiredRole(user.value?.role, item.role))
  }

  const filterItems = (items) => {
    // Filter out items that don't pass the filter, and recursively filter out their children
    return items
      .filter((item) => passesFilter(item))
      .map((item) => {
        if (item.key) {
          item.name = t(item.key)
        }
        if ('children' in item) {
          return {
            ...item,
            activePath: item.activePath
              ? localePath(item.activePath, locale.value)
              : undefined,
            children: filterItems(item.children),
          }
        }

        return {
          ...item,
          activePath: item.activePath
            ? localePath(item.activePath, locale.value)
            : undefined,
          to: item?.to ? localePath(item.to, locale.value) : undefined,
        }
      })
  }

  const accessibleItems = computed(() => filterItems(sidebarItems))

  return {
    accessibleItems,
  }
}
